module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-08-933f1ab6537ccc9fb9d6049fcfa9747a.svg";